/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ITakerCallback,
  ITakerCallbackInterface,
} from "../ITakerCallback";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "callbackData",
        type: "bytes",
      },
    ],
    name: "zeroExTakerCallback",
    outputs: [
      {
        internalType: "bytes4",
        name: "success",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class ITakerCallback__factory {
  static readonly abi = _abi;
  static createInterface(): ITakerCallbackInterface {
    return new utils.Interface(_abi) as ITakerCallbackInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ITakerCallback {
    return new Contract(address, _abi, signerOrProvider) as ITakerCallback;
  }
}
